import { ReactNode, useEffect } from "react";
import useModal from "../../hooks/useModal";
import ConfirmModal from "../ui/ConfirmModal";
import ColumnListModal from "./ColumnListModal";
import SuccessModal from "./SuccessModal";

type ReportRequestModalType = {
  handleSubmit: (columnList?: string[]) => void;
  isLoading?: boolean;
  isSuccess?: boolean;
  detailsMessage?: ReactNode;
  open: boolean;
  handleClose: () => void;
  columnList?: string[];
};

export default function RequestDateWithOutDateModal({
  handleSubmit,
  isLoading,
  isSuccess,
  detailsMessage,
  columnList,
  ...rest
}: ReportRequestModalType) {
  const { open, handleClose, handleOpen } = useModal<
    undefined,
    "SUCCESS" | "COLUMN_LIST"
  >();

  useEffect(() => {
    if (isSuccess) {
      handleOpen({ type: "SUCCESS" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  const onSubmit = () => {
    if (columnList?.length) {
      handleOpen({ type: "COLUMN_LIST" });
    } else {
      handleSubmit();
    }
  };

  return (
    <>
      {open?.type === "SUCCESS" && (
        <SuccessModal open={open?.open} handleClose={handleClose} />
      )}

      {open?.type === "COLUMN_LIST" && (
        <ColumnListModal
          open={open?.open}
          columnList={columnList!}
          handleClose={handleClose}
          handleSubmit={(selected) => {
            handleSubmit(selected);
          }}
        />
      )}

      <ConfirmModal
        handleOk={onSubmit}
        title="Confirm Request"
        hideAlert
        okText="Confirm"
        okButtonProps={{
          className: "!rounded !min-w-[110px]",
          loading: isLoading,
        }}
        cancelButtonProps={{
          className: "cancel-btn !min-w-[110px]",
        }}
        width={500}
        {...rest}
      >
        {detailsMessage ? (
          <div className="self-stretch justify-start text-slate-600 text-sm font-normal mb-3">
            {detailsMessage}
          </div>
        ) : null}
        <div className="self-stretch justify-start text-slate-600 text-sm font-normal">
          Are you sure you want to submit this request?
        </div>
        <div className="p-4 mt-4 bg-amber-100 rounded text-[#664D03]">
          You can request a report 2 times a day, and total 5 times a month,
          Maximum time range for a Report is 12 months, Processing time may take
          up to 24 hours.
        </div>
      </ConfirmModal>
    </>
  );
}
